import { useEffect } from 'react';
import { useTablePresets } from './useTablePresets';

/**
 * Держит применённый пресет в его текущем виде: правку, внесённую в общий пресет обладателем
 * разрешения, подхватывает молча — пока пользователь сам этот вид не донастраивал.
 *
 * Донастроенный вид не трогает: он остаётся за пользователем вместе с предложением сохранить его
 * личной копией (у обладателя разрешения — записать в пресет). Пресет, применённый набором
 * настроек прежней версии, отметки о виде применения не имеет — пока вид таблицы совпадает
 * с пресетом, отметка проставляется, и дальше такой пресет обновляется наравне с остальными.
 *
 * Живёт на уровне страницы: подхват нужен один раз на открытие списка, а не в каждом
 * потребителе пресетов.
 *
 * @param sectionKey - Ключ рабочей записи: имя таблицы (например, `'dialogsListV2'`) либо ключ
 * раздела закреплённого пресета — свой применённый пресет и свой вид есть у каждого раздела.
 */
export const useActivePresetRefresh = (sectionKey: string) => {
  const { activePreset, activePresetView, isDirty, isOutdated, apply, rememberAppliedView } =
    useTablePresets(sectionKey);

  useEffect(() => {
    if (!activePreset) return;
    if (isOutdated) {
      // Применение пресета заново заменяет вид таблицы его текущим видом и обновляет отметку
      apply(activePreset.id);
      return;
    }
    if (!activePresetView && !isDirty) rememberAppliedView(activePreset.settings);
  }, [activePreset, activePresetView, isDirty, isOutdated, apply, rememberAppliedView]);
};
